/** Platform type for a social/destination account */
export type DestinationType = "yt" | "fb" | "ttv" | "ig" | "s3" | "tt";

/** Max length for clip title across all publication destinations. */
export const TITLE_MAX_LENGTH = 200;

/** Connected destination (social account or CDN) */
export interface SocialAccount {
  id: string;
  platform: string;
  name: string;
  connected: boolean;
  type: DestinationType;
  /** Full path to platform icon SVG (e.g. for inlineSVG). */
  icon: string;
  /** CSS class for platform brand color (e.g. platform--youtube). */
  iconCssClass: string;
  /**
   * Selected in the project but missing from the tenant destinations catalog
   * (disabled / deleted). Shown so the user can uncheck it; not for settings load.
   */
  unavailable?: boolean;
}

/** Label for project destinations that no longer exist in the tenant catalog. */
export const UNAVAILABLE_DESTINATION_DISPLAY_NAME = "Deleted destination";

/** Placeholder SocialAccount for a selected UID absent from the live catalog. */
export function createUnavailableSocialAccount(id: string): SocialAccount {
  return {
    id,
    platform: "Unknown",
    name: UNAVAILABLE_DESTINATION_DISPLAY_NAME,
    connected: false,
    type: "s3",
    icon: "/assets/publishing-status/globe.svg",
    iconCssClass: "platform--website",
    unavailable: true,
  };
}

/** Per-destination publish config */
export interface DestinationConfig {
  aspectRatio: import("app/js/src/domain/clipping-studio/aspect-ratio").AspectRatio;
}

/** AI generate-metadata API response (title, tags, message). */
export interface GenerateMetadataResponse {
  title: string;
  tags: string;
  message: string;
}

/** Per-destination metadata override (optional fields; only overridden fields are set). */
export interface DestinationMetadataOverride {
  title?: string;
  message?: string;
  tags?: string;
}

/** Full metadata state for the Meta-Data tab */
export interface PublishMetadata {
  title: string;
  message: string;
  tags: string;
}
